import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "filter" }
const _hoisted_2 = { class: "header-container" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "filter-legend" }
const _hoisted_5 = { class: "filters" }
const _hoisted_6 = {
  key: 0,
  class: "inputWrap"
}
const _hoisted_7 = {
  key: 1,
  class: "inputWrap"
}
const _hoisted_8 = {
  key: 2,
  class: "inputWrap"
}
const _hoisted_9 = {
  key: 3,
  class: "inputWrap"
}
const _hoisted_10 = {
  key: 4,
  class: "dateInputWrap"
}
const _hoisted_11 = {
  key: 5,
  class: "dateInputWrap"
}
const _hoisted_12 = {
  key: 6,
  class: ""
}
const _hoisted_13 = {
  key: 7,
  class: ""
}
const _hoisted_14 = { class: "inputWrap noMarginLeft" }
const _hoisted_15 = {
  key: 8,
  class: "inputWrap"
}
const _hoisted_16 = {
  key: 0,
  class: "btnWrapper"
}
const _hoisted_17 = { class: "btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_NumberInput = _resolveComponent("NumberInput")!
  const _component_ButtonWhite = _resolveComponent("ButtonWhite")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!
  const _component_AccordionItem = _resolveComponent("AccordionItem")!
  const _component_AccordionList = _resolveComponent("AccordionList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.hideHeader)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.$t('title.search')), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_AccordionList, { class: "container-accordion" }, {
        default: _withCtx(() => [
          _createVNode(_component_AccordionItem, {
            class: "cursor-pointer",
            onClick: _ctx.toggleAccordion,
            onKeydown: [
              _withKeys(_ctx.toggleAccordion, ["enter"]),
              _withKeys(_withModifiers(_ctx.toggleAccordion, ["prevent"]), ["space"])
            ],
            open: _ctx.accordionOpen,
            tabindex: "0"
          }, {
            summary: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('facture.suivi.criteresAvances')), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("fieldset", {
                class: "filter-fieldset filterAndButtons",
                onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("legend", _hoisted_4, _toDisplayString(_ctx.$t('title.search')), 1),
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.filter.numeroFacture !== undefined)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_TextInput, {
                          class: "filterInput",
                          modelValue: _ctx.filterNumeroFacture,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterNumeroFacture) = $event)),
                          label: _ctx.$t('facture.filter.numeroFacture')
                        }, null, 8, ["modelValue", "label"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.filter.societe !== undefined)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_TextInput, {
                          class: "filterInput",
                          modelValue: _ctx.filterSociete,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterSociete) = $event)),
                          label: _ctx.$t('facture.filter.societe')
                        }, null, 8, ["modelValue", "label"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.filter.etablissement !== undefined)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_TextInput, {
                          class: "filterInput",
                          modelValue: _ctx.filterEtablissement,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterEtablissement) = $event)),
                          label: _ctx.$t('facture.filter.etablissement')
                        }, null, 8, ["modelValue", "label"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.filter.fournisseur !== undefined)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_TextInput, {
                          class: "filterInput",
                          modelValue: _ctx.filterFournisseur,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterFournisseur) = $event)),
                          label: _ctx.$t('facture.filter.fournisseur')
                        }, null, 8, ["modelValue", "label"])
                      ]))
                    : _createCommentVNode("", true),
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "full-width-break" }, null, -1)),
                  (_ctx.filter.dateFrom !== undefined)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_DatePicker, {
                          "date-max": _ctx.filter.dateTo,
                          dateValue: _ctx.filter.dateFrom,
                          label: _ctx.$t('facture.filter.dateFrom'),
                          onSetDate: _ctx.setFilterDateFrom
                        }, null, 8, ["date-max", "dateValue", "label", "onSetDate"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.filter.dateTo !== undefined)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(_component_DatePicker, {
                          dateValue: _ctx.filter.dateTo,
                          label: _ctx.$t('facture.filter.dateTo'),
                          onSetDate: _ctx.setFilterDateTo,
                          dateMin: _ctx.filter.dateFrom
                        }, null, 8, ["dateValue", "label", "onSetDate", "dateMin"]),
                        _createVNode(_component_ReglePastille, {
                          cle: "facturation.filtreDatesIncoherentes",
                          placement: "bottom"
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.comparisonList !== undefined)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(_component_DropDown, {
                          label: _ctx.$t('facture.filter.montantTTC'),
                          list: _ctx.comparisonList,
                          selectedItem: _ctx.filter.comparison,
                          display: _ctx.displayType,
                          onSelect: _ctx.selectComparison,
                          class: "width-250px"
                        }, null, 8, ["label", "list", "selectedItem", "display", "onSelect"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.comparisonList !== undefined && _ctx.filter.comparison !== _ctx.$t('facture.suivi.dropdown.novalue'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_NumberInput, {
                            class: _normalizeClass(["filterInput", _ctx.filterMontant !== '' ? 'montant' : '']),
                            modelValue: _ctx.filterMontant,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterMontant) = $event)),
                            label: _ctx.$t('facture.filter.montantTTC')
                          }, null, 8, ["modelValue", "label", "class"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.filter.joursRetard !== undefined)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createVNode(_component_NumberInput, {
                          class: "filterInput",
                          modelValue: _ctx.filterJoursRetard,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterJoursRetard) = $event)),
                          label: _ctx.$t('facture.filter.joursRetard')
                        }, null, 8, ["modelValue", "label"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (!_ctx.hideButton)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_ButtonWhite, {
                          onClick: _ctx.clearFilter,
                          class: "clearBtn",
                          text: _ctx.$t('button.clear')
                        }, null, 8, ["onClick", "text"]),
                        _createVNode(_component_ButtonBlue, {
                          disabled: _ctx.disabled,
                          onClick: _ctx.search,
                          class: "searchBtn",
                          text: _ctx.$t('button.search')
                        }, null, 8, ["disabled", "onClick", "text"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["onClick", "onKeydown", "open"])
        ]),
        _: 1
      })
    ])
  ]))
}